import { Accordion } from '@design/components/accordion/Accordion';
import { createFaviconUrl } from '@terminal/views/alfred/research/utils/createFaviconUrl';
import { useTranslation } from 'react-i18next';

import styles from './CitationsSection.module.scss';

export interface CitationsSectionProps {
  title: string;
  count: number;
  items: { title: string; url: string }[];
  isExpanded?: boolean;
}

export const CitationsSection = ({
  title,
  count,
  items,
  isExpanded = false,
}: CitationsSectionProps) => {
  const { t } = useTranslation(['earnings']);

  const handleItemClick = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const accordionItems = [
    {
      title: (
        <div className={styles.titleContainer}>
          <span className={styles.titleLabel}>{title}</span>
          <span className={styles.countLabel}>
            {t('earnings:earningsInsight.drawer.count', { count })}
          </span>
        </div>
      ),
      content: (
        <div className={styles.itemsWrapper}>
          {items.map((item, index) => {
            const favicon = createFaviconUrl(item.url);

            return (
              <div
                className={styles.itemContainer}
                key={index}
                onClick={() => handleItemClick(item.url)}
              >
                {favicon && (
                  <img className={styles.styledFavicon} src={favicon} />
                )}
                <div className={styles.itemContent}>
                  <span className={styles.citationTitle}>{item.title}</span>
                  <span className={styles.citationUrl}>{item.url}</span>
                </div>
              </div>
            );
          })}
        </div>
      ),
      expandedByDefault: isExpanded,
    },
  ];
  return (
    <Accordion className={styles.styledAccordion} items={accordionItems} />
  );
};
